import { JSX } from "react";
import { FaBaseballBall, FaBasketballBall, FaHockeyPuck } from "react-icons/fa";
import { FaFootball } from "react-icons/fa6";
// import { GiSoccerBall } from "react-icons/gi";

export type League = 'mlb' | 'nba' | 'nhl' | 'nfl';
// export type League = 'mlb' | 'nba' | 'nhl' | 'nfl' | 'epl';

export const LEAGUE_OPTIONS: Record<League, { label: string; icon: JSX.Element }> = {
  mlb: { label: "MLB", icon: <FaBaseballBall /> },
  nba: { label: "NBA", icon: <FaBasketballBall /> },
  nhl: { label: "NHL", icon: <FaHockeyPuck /> },
  nfl: { label: "NFL", icon: <FaFootball /> },
  // epl: { label: "EPL", icon: <GiSoccerBall /> },
};
